import { StoreTeam } from "@coworker/types/lib/storeteam";
import { useQuery } from "@tanstack/react-query";
import { useAllStoreUsers } from "@coworker/apprestructured/src/shared/hooks/users/useAllStoreUsers";
import { getStoreTeams } from "@coworker/app/src/hooks/API/core.service";
import { INTERVAL } from "@coworker/app/src/constants/clientTime";

const useTeamsWithUsersCount = (storeId: string) => {
  const { data: storeUsers, isLoading: isLoadingUsers } =
    useAllStoreUsers(storeId);

  // Create a hash or use the length + specific user-team mappings to ensure reactivity
  // If improved in the future, use a count form the backend SQL query instead.
  // Unable to fix in core-service due to package issues
  const usersDataHash = storeUsers
    ? storeUsers
        .map((user) => `${user.uid}-${user.teamId}`)
        .sort()
        .join("|")
    : null;

  return useQuery<StoreTeam[]>({
    queryKey: ["storeTeamsWithUsersCount", storeId, usersDataHash],
    queryFn: async () => {
      const teamsData = await getStoreTeams(storeId);
      const teamsWithUsersCount = teamsData.map((team: StoreTeam) => {
        const user_count =
          storeUsers?.filter((user) => user.teamId === team.id).length || 0;
        return { ...team, user_count };
      });
      return teamsWithUsersCount;
    },
    enabled: !isLoadingUsers && !!storeUsers,
    staleTime: 5 * INTERVAL.MINUTE,
    gcTime: 10 * INTERVAL.MINUTE,
  });
};

export default useTeamsWithUsersCount;
